// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2277":"css/admin-app.6861","6567":"css/app.6861"}[chunkId] + ".css";
};